import withStyles from '@mui/styles/withStyles';
import Button, { ButtonProps } from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import type { Theme } from '@mui/material/styles';

const ButtonPrimaryBase = withStyles((theme: Theme) => ({
  root: {
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: theme.typography.pxToRem(16),
    padding: '12px 16px',
    lineHeight: 1,
    height: theme.typography.pxToRem(42),
    minWidth: theme.typography.pxToRem(133),
    color: theme.palette.common.black,

    outlined: {
      border: `1px solid ${theme.palette.common.black}`,
    },

    '&:hover': {
      backgroundColor: theme.palette.darkGrey[5],
      boxShadow: 'none',
    },

    '&:active': {
      boxShadow: 'none',
      backgroundColor: theme.palette.darkGrey[5],
    },

    '&:focus': {
      backgroundColor: theme.palette.darkGrey[5],
    },
  },
}))(Button);

interface Props extends ButtonProps {
  loading?: boolean;
}

function ButtonOutlined({ loading, ...others }: Props) {
  return (
    <ButtonPrimaryBase
      disableElevation
      disableRipple
      endIcon={loading && <CircularProgress color="inherit" size={18} />}
      variant="outlined"
      {...others}
    />
  );
}

export default ButtonOutlined;
